// Customer-facing name of the prepaid Wallet. Internal identifiers (prepaid_accounts, prepaid_ledger, DEPOSIT…) never change.
export const walletName = (business) => {
  const custom = (business?.wallet_display_name || "").trim();
  if (custom) return custom;
  return `${(business?.name || "Customer").trim()} Wallet`;
};

export const WALLET_TYPE_LABELS = {
  DEPOSIT: "Funds Added", PURCHASE: "Purchase", SALE_REFUND: "Refund to Wallet", BALANCE_REFUND: "Wallet Balance Refund",
  ADJUSTMENT_CREDIT: "Adjustment (Added)", ADJUSTMENT_DEBIT: "Adjustment (Deducted)",
};

export const TERMINAL_REQUIRED_TITLE = "Wallet funds must be added from a registered P-O-S terminal.";
export const TERMINAL_REQUIRED_TEXT = "Please open this customer on a registered register to add funds. You can still view the Wallet balance, activity, statements and reports from this device.";

// Registered-terminal check shared by Wallet actions. Mirrors backend require_pos_register: blocks ONLY when enforcement is ON
// and this browser has no active/legacy POS register (status "required"), or the staff member is not assigned/authorized for it.
// Note: a "Trusted NEEC Terminal" (Quick Login trust) is NOT a POS register — registers are created in Settings → POS Registers.
export const terminalState = (api) => api.get("/pos/register/me").then((r) => {
  const s = r.data || {};
  const blocked = !!(s.enforcement && s.status !== "not_applicable" && !["ok", "legacy"].includes(s.status));
  return { ok: !blocked, status: s.status, register: s.register };
}).catch(() => ({ ok: true, status: "unknown" }));
export const terminalOk = (api) => terminalState(api).then((s) => s.ok);
export const TERMINAL_STATUS_TEXT = {
  not_assigned: "You are not assigned to this register's location. Ask your Owner or Manager to assign you, or use a register at your location.",
  not_authorized: "You are not authorized to use this register. Ask your Owner to add it to your allowed registers.",
};
